import React from 'react'
import StatisticalForecastTable from './Table/StatisticalForecastTable'

export default function TableStatisticalUI({ selectedItemName, refreshCount, onRefreshComplete, isEditEnabled }) {
  return (
    <div className='h-[70vh]'>
      <StatisticalForecastTable selectedItemName={selectedItemName} refreshCount={refreshCount} onRefreshComplete={onRefreshComplete} isEditEnabled={isEditEnabled} />
    </div>
  )
}
